class FangedSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.controls = this.querySelector('.hero__controls-inner');
    this.mobileMediaQuery = matchMedia('(max-width: 680px)');
    this.index = 0;
    this.delay = Number(this.dataset.delay || 3) * 1000;
    this.autoplay = this.dataset.autoplay === 'true';
    this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));
    this.querySelectorAll('.hero__media').forEach(media => media.addEventListener('click', () => {
      if (this.mobileMediaQuery.matches) this.go(this.index + 1);
    }));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.syncControls());
      this.resizeObserver.observe(this);
    }
    requestAnimationFrame(() => this.syncControls());
    this.start();
  }
  go(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === this.index); slide.setAttribute('aria-hidden', i !== this.index); });
    this.dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === this.index); dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'); });
    requestAnimationFrame(() => this.syncControls());
    this.start();
  }
  syncControls() {
    const activeSlide = this.slides[this.index];
    const target = activeSlide?.querySelector('.hero__title') || activeSlide?.querySelector('.hero__copy');
    if (!this.controls || !target) return;

    const heroRect = this.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const textAlign = getComputedStyle(target).textAlign;
    const justify = textAlign === 'center'
      ? 'center'
      : ['right', 'end'].includes(textAlign) ? 'flex-end' : 'flex-start';

    this.controls.style.setProperty('--hero-controls-inline-start', `${targetRect.left - heroRect.left}px`);
    this.controls.style.setProperty('--hero-controls-width', `${targetRect.width}px`);
    this.controls.style.setProperty('--hero-controls-justify', justify);
  }
  disconnectedCallback() {
    this.stop();
    this.resizeObserver?.disconnect();
  }
  start() { this.stop(); if (this.autoplay && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.timer = setInterval(() => this.go(this.index + 1), this.delay); }
  stop() { if (this.timer) clearInterval(this.timer); }
}
customElements.define('fanged-slideshow', FangedSlideshow);

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.matches?.('[data-slide]') ? event.target : event.target.querySelector?.('[data-slide]');
    const slideshow = slide?.closest('fanged-slideshow');
    if (!slide || !slideshow) return;
    slideshow.go(slideshow.slides.indexOf(slide));
    slideshow.stop();
  });
  document.addEventListener('shopify:block:deselect', event => {
    event.target.closest?.('fanged-slideshow')?.start();
  });
}

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
menuButton?.addEventListener('click', () => {
  const open = mobileMenu.classList.toggle('is-open');
  document.body.classList.toggle('menu-open', open);
  menuButton.setAttribute('aria-expanded', String(open));
});

document.querySelectorAll('[data-sort-by]').forEach(select => {
  select.addEventListener('change', event => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.href = url.toString();
  });
});

document.querySelectorAll('[data-quantity]').forEach(input => {
  input.addEventListener('change', () => input.form?.requestSubmit());
});
